import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '35px',
  },
  stepHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
    fontSize: '16px',
    marginBottom: '20px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 150ms',
  },
  stepHeaderChecked: {
    width: '19px',
    height: '18px',
    marginRight: '9px',
  },
  stepHeaderNum: {
    marginRight: '9px',
    fontSize: '13px',
    borderRadius: '50%',
    border: '2px solid #fff',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2px',
  },
  proTag: {
    fontSize: '12px',
    color: '#000',
    backgroundColor: '#D1FE75',
    padding: '5px 4px',
    borderRadius: '4px',
    marginLeft: '10px',
  },
  noMargin: {
    margin: '0!important',
  },
  disabled: {
    opacity: '0.5',
    cursor: 'default !important',
  },
  greyout: {
    color: '#888888',
    '& $stepHeaderNum': {
      border: '2px solid #888888',
    },
  },
  compactTooltip: {
    maxWidth: '26rem',
  },
  tooltipImg: {
    [theme.breakpoints.down('xs')]: {
      width: '14px',
    },
    margin: '0 10px 0 5px',
    width: '16px',
  },
  section: {
    [theme.breakpoints.down('xs')]: {
      padding: '15px 10px',
    },
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#1c1c1c',
    padding: '20px',
    marginBottom: '20px',
    transition: 'opacity 150ms',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  promptMethodContainer: {
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    alignItems: 'center',
    color: '#404040',
    overflow: 'hidden',
  },
  promptMethod: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '14px',
    padding: '6px 9px',
    cursor: 'pointer',
    transition: 'opacity 150ms',
    borderRadius: '6px',
    border: '1px solid #404040',
  },
  selectedPromptMethod: {
    backgroundColor: '#292929',
    color: '#fff',
  },
  switchContainer: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '14px',
    color: '#fff',
  },
  switch: {
    marginLeft: '8px!important',
    padding: '0px!important',
    '& .MuiSwitch-track': {
      borderRadius: '11px!important',
      opacity: '1!important',
      backgroundColor: '#1C1C1C',
      border: '1px solid #292929',
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '12px!important',
        height: '12px!important',
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: '14px!important',
      height: '14px!important',
      margin: '1px!important',
    },
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#292929',
          opacity: '1!important',
          border: '1px solid #404040',
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: '0.5!important',
        },
      },
    },
  },
  textInput: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px !important',
    },
    fontFamily: 'inherit',
    fontSize: '14px',
    padding: '0 12px',
    width: '100%',
    height: '36px',
    color: '#fff',
    backgroundColor: '#292929',
    border: '1px solid #404040',
    borderRadius: '8px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  autocomplete: {
    '& .MuiPaper-root-MuiAutocomplete-paper': {
      fontSize: '10px!important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-sizeSmall': {
      padding: '4px 36px 4px 12px !important',
      gap: '4px',
      minHeight: '34px',
      fontFamily: 'inherit',
    },
    '& .MuiAutocomplete-tag': {
      margin: '0',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px!important',
      },
      fontSize: '14px',
      padding: '0!important',
      color: '#fff!important',
      '&::placeholder': {
        color: '#757575!important',
        opacity: '1!important',
      },
    },
  },
  autocompletePaper: {
    '& .MuiAutocomplete-noOptions': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px',
      },
      fontSize: '14px',
      padding: '6px 16px',
      marginTop: '6px',
      border: '1px solid #404040',
      borderRadius: '8px',
    },
  },
  autocompleteList: {
    marginTop: '6px!important',
    border: '1px solid #404040!important',
    borderRadius: '8px!important',
    padding: '0!important',
    '& .MuiAutocomplete-option': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px!important',
      },
      fontSize: '14px',
      minHeight: '36px!important',
    },
  },
  randomTagsOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    marginTop: '12px',
    color: '#888888',
  },
  randomTagsContainer: {
    display: 'flex',
    gap: '8px 6px',
    overflowX: 'auto',
    flexDirection: 'row',
    paddingBottom: '8px',
    '&::-webkit-scrollbar': {
      height: '4px',
      width: '4px',
      borderRadius: '8px',
      background: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '8px',
    },
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '300',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    backgroundColor: '#292929',
    borderRadius: '6px',
    border: '1px solid #404040',
    cursor: 'pointer',
  },
  languageSelect: {
    '& .MuiSelect-select': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px!important',
      },
      padding: '0 8px!important',
      paddingRight: '24px!important',
      minHeight: '24px!important',
      lineHeight: '26px!important',
      fontSize: '14px',
      border: '1px solid #404040!important',
    },
    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#404040',
      },
      '&:hover fieldset': {
        borderColor: '#404040',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#404040',
      },
    },
    '& .MuiSelect-icon': {
      fontSize: '20px!important',
      right: '4px!important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none!important',
    },
  },
  textAreaContainer: {
    position: 'relative',
    color: '#fff',
    border: '1px solid #404040',
    borderRadius: '8px',
    backgroundColor: '#292929',
    paddingTop: '10px',
    overflow: 'hidden',
  },
  textArea: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
    },
    verticalAlign: 'top',
    resize: 'none',
    width: '100%',
    fontSize: '14px',
    fontFamily: 'inherit',
    lineHeight: '20px',
    color: '#fff',
    border: 'none',
    backgroundColor: '#292929',
    padding: '0px 12px 8px 12px',
    '&:focus': {
      outline: 'none',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888888',
      borderRadius: '8px',
    },
  },
  textAreaFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: '10px',
    width: '100%',
  },
  textAreaCount: {
    color: '#cfcfcf',
    fontSize: '11px',
  },
  lyricLabelButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px',
    color: '#fff',
    backgroundColor: '#292929',
    borderRadius: '4px',
    border: '1px solid #404040',
    width: 'fit-content',
    height: 'fit-content',
  },
  lyricLabelContainer: {
    fontSize: '14px',
    color: '#fff',
    backgroundColor: '#292929',
    marginBottom: '8px',
    borderRadius: '4px',
    border: '1px solid #404040',
  },
  lyricLabel: {
    fontSize: '13px',
    padding: '10px',
  },
  popover: {
    '& .MuiPopover-paper': {
      backgroundColor: 'transparent',
      overflow: 'hidden',
      fontFamily: 'TheJamsil',
    },
  },
  card: {
    [theme.breakpoints.down('xs')]: {
      padding: '15px 10px',
    },
    padding: '20px',
    marginBottom: '20px',
    display: 'flex',
    backgroundColor: '#1c1c1c',
    borderRadius: '8px',
    width: '100%',
    transition: 'opacity 150ms',
  },
  coverImg: {
    userSelect: 'none',
    width: '76px',
    height: '74px',
    borderRadius: '8px',
    border: '1px solid #404040',
  },
  cardSecondColumn: {
    [theme.breakpoints.down('xs')]: {
      padding: '6px 10px',
    },
    display: 'flex',
    overflow: 'hidden',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '6px 15px',
  },
  cardLabel: {
    fontSize: '16px',
    color: '#ffffff',
    overflow: 'hidden',
    textWrap: 'nowrap',
    textOverflow: 'ellipsis',
  },
  cardUsername: {
    fontSize: '12px',
    textOverflow: 'ellipsis',
    color: '#cfcfcf',
    marginTop: '5px',
  },
  cardDetails: {
    display: 'flex',
    fontSize: '12px',
    color: '#cfcfcf',
    lineHeight: '13.5px',
  },
  unLikedImg: {
    fontSize: '13px!important',
  },
  likedImg: {
    fontSize: '13px!important',
    color: '#d32f2f',
  },
  numberLikes: {
    marginLeft: '3px',
  },
  cardDetailSeparator: {
    margin: '0 4px',
  },
  playButtonGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 2px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  playButtonImg: {
    color: '#ffffff',
    width: '22px!important',
    height: '22px!important',
    cursor: 'pointer',
  },
  clearButtonImg: {
    margin: '0',
    cursor: 'pointer',
    color: '#ffffff',
    width: '20px!important',
    height: '20px!important',
  },
  selectVoiceButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '15px 10px',
    },
    padding: '20px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    backgroundColor: '#1c1c1c',
    justifyContent: 'space-between',
    minHeight: '90px',
    gap: '12px',
    cursor: 'pointer',
    transition: 'opacity 150ms',
  },
  selectVoiceButtonText: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  outputButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    gap: '12px',
    marginTop: '12px',
  },
  extensionButton: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: '300',
    color: '#9a9a9a',
    borderRadius: '8px',
    cursor: 'pointer',
    width: '74px',
    height: '36px',
    border: '1px solid #404040',
    backgroundColor: '#292929',
  },
  extensionSelected: {
    fontWeight: '400',
    border: '1px solid #B9FF66',
    color: '#B9FF66',
  },
  submitContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '18px',
    },
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  submitButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
      fontSize: '14px',
      minWidth: '100px',
    },
    justifyContent: 'center',
    backgroundColor: '#CAFF73',
    padding: '10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'pointer',
  },
  progressButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 10px 10px 15px',
      fontSize: '11px',
      minWidth: '95px',
    },
    backgroundColor: '#A4A4A4!important',
    padding: '10px 20px 10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'not-allowed',
    display: 'flex',
  },
  disabledButton: {
    backgroundColor: '#A4A4A4!important',
    cursor: 'not-allowed',
  },
  creditUsageText: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#fff',
    paddingBottom: '3px',
  },
  submitInfo: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'right',
    },
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '300',
    color: '#cfcfcf',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
  },
  loadingText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      lineHeight: '18px',
    },
    fontSize: '14px',
    marginLeft: '16px',
    lineHeight: '20px',
    fontWeight: '300',
  },
  loadingCircle: {
    [theme.breakpoints.down('xs')]: {
      width: '11px!important',
      height: '11px!important',
      marginLeft: '5px',
    },
    marginLeft: '5px',
    width: '15px!important',
    height: '15px!important',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#686868',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
}));

export { useStyles };
